"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualModal = ContextualModal;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_aria_1 = require("react-aria");
const Css_1 = require("../../Css");
const utils_1 = require("../../utils");
function ContextualModal(props) {
    const { content, title, close } = props;
    const tid = (0, utils_1.useTestIds)(props, "popup");
    return ((0, jsx_runtime_1.jsx)(react_aria_1.FocusScope, { restoreFocus: true, autoFocus: true, children: (0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.p3.df.fdc.gap3.bgWhite.bshModal.br4.maxh("inherit").oa.$, ...tid, children: [title && ((0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.lg.tac.$, ...tid.title, children: title })), (0, jsx_runtime_1.jsx)("div", { ...tid.content, children: typeof content === "function" ? content(close) : content })] }) }));
}
